// Токены дизайн-системы в CSS-переменные.
//
// Генератора здесь намеренно нет. Он дал бы третий файл, который обязан
// совпадать с двумя другими, — а расходятся такие файлы молча. Вместо этого
// переменные собираются из @smyslika/ui-tokens прямо в бандле: разойтись им
// не с чем, потому что источник один.
//
// Цвет берётся в oklch, а не в hex: браузер понимает его лучше, и на широких
// экранах accent-text с accent-link не теряют насыщенности, которую в sRGB
// пришлось бы обрезать. Hex в токенах лежит для React Native (P9).

import { COLORS, FOCUS_RING, MOTION, RADII, SHADOWS, TEXT, WEB, type ColorName } from '@smyslika/ui-tokens'

const shadow = (s: (typeof SHADOWS)[keyof typeof SHADOWS]): string => {
  const base = COLORS[s.color as ColorName].oklch
  const color = base.replace(/^oklch\((.*)\)$/, `oklch($1 / ${s.alpha})`)
  return `${s.x}px ${s.y}px ${s.blur}px ${color}`
}

const ring = (): string => {
  const base = COLORS[FOCUS_RING.color as ColorName].oklch
  return `0 0 0 ${FOCUS_RING.width}px ${base.replace(/^oklch\((.*)\)$/, `oklch($1 / ${FOCUS_RING.alpha})`)}`
}

function build(): string {
  const lines: string[] = [':root {']

  for (const [name, token] of Object.entries(COLORS)) lines.push(`  --${name}: ${token.oklch};`)

  for (const [name, r] of Object.entries(RADII)) lines.push(`  --radius-${name}: ${r}px;`)
  for (const [name, s] of Object.entries(SHADOWS)) lines.push(`  --shadow-${name}: ${shadow(s)};`)
  lines.push(`  --focus-ring: ${ring()};`)

  lines.push(`  --nav-width: ${WEB.columns.nav}px;`)
  lines.push(`  --header-height: ${WEB.header}px;`)
  lines.push(`  --header-compact: ${WEB.headerCompact}px;`)
  lines.push(`  --feed-header-height: ${WEB.feedHeader}px;`)
  lines.push(`  --content-x: ${WEB.content.x}px;`)
  lines.push(`  --content-y: ${WEB.content.y}px;`)
  lines.push(`  --composer-bottom: ${WEB.content.composerBottom}px;`)
  lines.push(`  --hit-row: ${WEB.hit.row}px;`)
  lines.push(`  --hit-button: ${WEB.hit.button}px;`)
  lines.push(`  --hover-ms: ${WEB.transition.hover}ms;`)
  lines.push(`  --sources-ms: ${WEB.transition.sources}ms;`)

  // Движение окон. Те же числа, что у шита на телефоне, — `MOTION` общий, и
  // одинаково ощущаться окно обязано на обеих платформах.
  lines.push(`  --sheet-in-ms: ${MOTION.sheet.in}ms;`)
  lines.push(`  --sheet-out-ms: ${MOTION.sheet.out}ms;`)
  lines.push(`  --scrim-in-ms: ${MOTION.scrim.in}ms;`)
  lines.push(`  --pop-ms: ${MOTION.pop}ms;`)
  lines.push(`  --ease-out: cubic-bezier(${MOTION.ease.join(', ')});`)

  for (const [role, t] of Object.entries(TEXT)) {
    const family = t.font === 'Alegreya Sans' ? "'Alegreya Sans', Georgia, serif" : t.font === 'Manrope' ? "'Manrope', system-ui, sans-serif" : 'ui-monospace, monospace'
    // Размер в rem, а не в px. Число то же — 16 по умолчанию, — но человек,
    // увеличивший шрифт в настройках браузера, получает увеличенный шрифт и
    // здесь. С px он не получал ничего: это web-эквивалент Dynamic Type, и
    // без него «читаемость при системном увеличении» просто не работает.
    // В токенах числа остаются пикселями: rem — понятие веба, а те же токены
    // едут в React Native (P9), где его нет.
    lines.push(`  --text-${role}: ${t.weight} ${t.size / 16}rem/${t.lineHeight} ${family};`)
    if ('tracking' in t && t.tracking != null) lines.push(`  --tracking-${role}: ${t.tracking}em;`)
  }

  lines.push('}')
  return lines.join('\n')
}

/**
 * Ставится синхронно до первой отрисовки — иначе первый кадр вышел бы
 * бесцветным. Вызывается из main.tsx раньше рендера, а не из эффекта.
 */
export function installTokens(): void {
  const style = document.createElement('style')
  style.dataset.tokens = 'smyslika'
  style.textContent = build()
  document.head.prepend(style)
}

/** Ширина, ниже которой кабинет перестраивается по мобильным правилам. */
export const BREAKPOINT = WEB.breakpoint
